import React from "react";

const Fourohfour = () => {
  return <div>Uh oh. Something went wrong. Try something else.</div>;
};

export default Fourohfour;
